import { useEffect, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"

import axios from "axios"
import { useAuth } from "contexts/auth-context"
import { useLayoutEffect } from "react"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import Clone from "./clone"
import { Transition } from "components"
import moment from "moment"
import { useAuditLogContext } from "contexts/audit-log-context"

export default function Create() {
    const { user, isSuper } = useAuth()
    const { cache } = useSWRConfig()

    const { queueAuditLog } = useAuditLogContext()

    const { transition, setTransition } = usePage()

    const location = useLocation()
    const navigate = useNavigate()

    const [data, setData] = useState()

    const [prevRouteState, setPrevRouteState] = useState({})

    const [errors, setErrors] = useState({})

    useEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                from: location.state?.from,
                transition: location.state?.transition
            })
        }

        setTransition(location.state?.transition)
        setTransition({ type: "fade", reverse: false })

        getPrevRouteState()
    }, [])

    const handleSubmit = (data) => {
        nProgress.start()

        toast.loading("Memuat", {
            id: "submit"
        })

        const formData = new FormData()

        if (data.product_model_id)
            formData.append('product_model_id', data.product_model_id)

        if (data.name)
            formData.append('name', data.name)

        if (data.long_name)
            formData.append('long_name', data.long_name)

        if (data.sku)
            formData.append('sku', data.sku)
        if (data.description)
            formData.append('description', data.description)

        if (data.image)
            formData.append('image', data.image)

        if (data.pre_order)
            formData.append('pre_order', data.pre_order)

        if (data.referred_id)
            formData.append('referred_id', data.referred_id)

        for (let i = 0; i < data.bundle.length; i++) {
            for (let key of Object.keys(data.bundle[i])) {
                formData.append(`bundle[${i}][${key}]`, data.bundle[i][key])
            }
        }

        for (let i = 0; i < data.attribute.length; i++) {
            for (let key of Object.keys(data.attribute[i])) {
                formData.append(`attribute[${i}][${key}]`, data.attribute[i][key])
            }
        }

        for (let i = 0; i < data.price.length; i++) {
            for (let key of Object.keys(data.price[i])) {
                formData.append(`price[${i}][${key}]`, data.price[i][key])
            }
        }

        for (let i = 0; i < data.discount.length; i++) {
            for (let key of Object.keys(data.discount[i])) {
                formData.append(`discount[${i}][${key}]`, data.discount[i][key])
            }
        }

        for (let i = 0; i < data.reward.length; i++) {
            for (let key of Object.keys(data.reward[i])) {
                formData.append(`reward[${i}][${key}]`, data.reward[i][key])
            }
        }

        for (let i = 0; i < data.stock.length; i++) {
            for (let key of Object.keys(data.stock[i])) {
                formData.append(`stock[${i}][${key}]`, data.stock[i][key])
            }
        }

        formData.append('created_by', user?.name)

        const url = `${process.env.REACT_APP_INVENTORY_API_URL}/product/unit`
        const payload = {
            product_model_id: data.product_model_id,
            product_model: data.product_model?.name,
            name: data.name,
            description: data.description,
            long_name: data.long_name,
            sku: data.sku,
            referred_id: data.referred_id,
            pre_order: data.pre_order,
            // bundle: data.bundle,
            attribute: data.attribute.map((row) => {
                return {
                    attribute: row.attribute?.name,
                    attribute_group: row.attribute_group?.name,
                    attribute_group_id: row.attribute_group_id,
                    attribute_id: row.attribute_id
                }
            }),
            price: data.price.map((row) => {
                return {
                    active_date: row.active_date,
                    maximum_retail_price: row.maximum_retail_price,
                    price: row.price,
                    store_price: row.store_price,
                    dozen_price: row.dozen_price,
                    dozen_store_price: row.dozen_store_price,
                    outlet_id:row.outlet_id
                }
            }),
            discount: data.discount.map((row) => {
                return {
                    discount: row.discount?.name,
                    outlet_id:row.outlet_id,
                    discount_type_id: row.discount_type_id,
                    from_date: row.from_date,
                    to_date: row.to_date
                }
            }),
            reward: data.reward.map((row) => {
                return {
                    reward: row.reward?.name,
                    reward_type_id: row.reward_type_id,
                    from_date: row.from_date,
                    to_date: row.to_date
                }
            }),
            stock: data.stock.map((row) => {
                return {
                    outlet_id: row.outlet_id,
                    purchase_order_id: row.purchase_order_id,
                    purchase_date: row.purchase_date,
                    dos_date: row.dos_date,
                    amount: row.amount,
                    hpp_amount: row.hpp_amount,
                    maximum_retail_price: row.maximum_retail_price,
                    purchase_stock: row.purchase_stock,
                    current_stock: row.current_stock
                }
            }),
            created_by: user?.name,
        }

        axios.postForm(url, formData).then((response) => {
            // Queue audit log
            queueAuditLog(url, response.config.method.toUpperCase(), "Create Product Unit Data", user?.name, payload, null, moment().format('YYYY-MM-DD HH:mm:ss'), response.status)

            // Clear SWR cache
            cache.clear()

            // Navigate page
            navigate({ pathname: '/product/unit' })

            // Show toast message
            toast.success(response.data.message, {
                id: "submit"
            })
        }).catch((error) => {
            // Assign validation message
            if (error.response.status === 422) {
                setErrors(error.response.data.errors)
            }

            // Show toast message
            toast.error(error.response.data.message, {
                ariaProps: {
                    superscript: error.response.status
                },
                id: "submit"
            })
        })
    }

    return (
        <Transition type="slide" reversed={true}>
            <div className="flex justify-end w-full text-xs">
                <Clone onSubmit={(value) => setData(value)} />
            </div>
            <Form data={data} errors={errors} onSubmit={handleSubmit} />
        </Transition>
    )
}